<template>
	<base-modal-template>
		<div>
			<div v-show="loading"
			     class="blockingOverlay"></div>

			<div :class="{ 'modal-wrapper__inner--wide': wide}" class="modal-wrapper__inner">

				<div class="modal-wrapper__overlay"></div>

				<article class="modal-wrapper__wrapper">

					<div class="modal-wrapper__header">
						<button class="js-toggle-po-modal modal-wrapper__close" type="button" @click="cancel">
							<svg class="icon-modal-close" height="20" width="20">
								<use xlink:href="/assets/images/build/svg-sprite.min.svg#modal-close"></use>
							</svg>
						</button>
					</div>

					<template v-if="showSidebar">
						<div class="modal-wrapper__sidebar">
							<slot name="sidebar"></slot>
						</div>
					</template>

					<div :class="{'modal-wrapper__main': showSidebar}">
						<h2 class="modal-wrapper__title">
							<slot name="title"></slot>
						</h2>

						<div class="modal-wrapper__content">
							<slot></slot>
						</div>

						<div class="modal-wrapper__buttons">

							<slot name="buttons">
								<slot name="button-cancel">
									<button class="button button--white button--small" @click="cancel">
										{{
											cancelButtonText ? cancelButtonText : t('shoppingcart.generic.cancel.text')
										}}
									</button>
								</slot>

								<slot name="button-confirm">
									<button :class="confirmButtonClass"
									        class="button button--small"
									        type="button" @click="confirm">
										{{
											confirmButtonText ? confirmButtonText : t('shoppingcart.generic.confirm.text')
										}}
										<span class="button-spinner"></span>
									</button>
								</slot>
							</slot>

						</div>
					</div>

				</article>
			</div>
		</div>
	</base-modal-template>
</template>

<script lang="ts" setup>
	import {computed, useSlots} from 'vue';
	import {useI18n} from 'vue-i18n';
	import BaseModalTemplate from './BaseModalTemplate.vue';

	withDefaults(defineProps<{
		loading?: boolean;
		wide?: boolean;
		cancelButtonText: string;
		confirmButtonText: string;
		confirmButtonClass?: string;
	}>(), {
		loading: false,
		wide: false,
		confirmButtonClass: 'button--green',
	});

	const {t} = useI18n();
	const emits = defineEmits(['cancel', 'confirm']);
	const slots = useSlots();

	const showSidebar = computed(() => {
		return slots.sidebar;
	});

	const cancel = () => {
		emits('cancel');
	};

	const confirm = () => {
		emits('confirm');
	};
</script>
